"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserHashes = void 0;
const env_1 = require("./env");
const crypto_1 = require("./crypto");
const userHashesPerUserId = (userId) => {
    const firmwareSalt = (0, crypto_1.sha256)(userId + "|firmwareSalt")
        .toString("hex")
        .slice(0, 6);
    const endpointOverrides100 = (0, crypto_1.sha256)(userId + "|endpoint").readUInt16BE(0) % 100;
    return {
        firmwareSalt,
        endpointOverrides100,
    };
};
let cache;
const getUserHashes = () => {
    const userId = (0, env_1.getEnv)("USER_ID");
    if (cache && userId === cache.userId) {
        return cache.value;
    }
    cache = {
        userId,
        value: userHashesPerUserId(userId),
    };
    return cache.value;
};
exports.getUserHashes = getUserHashes;
//# sourceMappingURL=user.js.map